import React from 'react'
import './Logo.css'

export const Logo = () => {
  return (
    <div style={{backgroundColor:"rgb(16, 18, 57)"}}><img src="logo.png"></img></div>
  )
}
